export interface NotificationPreferences {
  syncUpdates: boolean;
  scriptReminders: boolean;
}

const PREFS_KEY = 'notification-preferences';

export const getStoredPreferences = (): NotificationPreferences => {
  try {
    const stored = localStorage.getItem(PREFS_KEY);
    return stored ? JSON.parse(stored) as NotificationPreferences : { syncUpdates: true, scriptReminders: true };
  } catch {
    return { syncUpdates: true, scriptReminders: true };
  }
};

export const setStoredPreferences = (prefs: NotificationPreferences): void => {
  localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
};

export const getNotificationPreferences = getStoredPreferences;
